import React, { useState, useEffect } from 'react';
import BlogLayout from './BlogLayout';
import { WORKER_URL } from '../../utils/api';

const DOR_LABEL = {
  'pedidos-atrasados': '🔔 Alertas',
  'dashboard-tempo-real': '📊 Dashboard',
  'flex-cores': '🟢 FLEX',
  'documentos-fiscais': '📄 Documentos',
  'perguntas-clientes': '💬 Perguntas',
  'fechar-mes': '📈 Relatórios',
};

function formatDate(iso) {
  return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
}

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${WORKER_URL}/api/blog?page=${page}`)
      .then(r => r.json())
      .then(d => { setPosts(d.posts || []); setPages(d.pages || 1); })
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <BlogLayout title="Blog" description="Dicas e estratégias para vendedores do Mercado Livre venderem mais com controle total.">
      {/* Hero */}
      <div style={{ background: '#1B2A7A', color: '#FAF8F3', padding: '64px 24px 56px', textAlign: 'center' }}>
        <div style={{ maxWidth: 700, margin: '0 auto' }}>
          <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 13, color: '#FFD400', letterSpacing: '0.12em', marginBottom: 16, textTransform: 'uppercase' }}>Blog — Integra MKP</p>
          <h1 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 900, fontSize: 'clamp(32px, 5vw, 56px)', lineHeight: 1.05, letterSpacing: '-0.03em', margin: '0 0 20px' }}>
            Tudo que vendedores do<br /><span style={{ color: '#FFD400' }}>Mercado Livre</span> precisam saber.
          </h1>
          <p style={{ fontSize: 18, color: 'rgba(250,248,243,0.8)', lineHeight: 1.5 }}>
            Dicas práticas, estratégias e novidades para você vender mais com mais controle.
          </p>
        </div>
      </div>

      {/* Posts grid */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '56px 24px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0', color: '#9CA3AF' }}>Carregando artigos...</div>
        ) : posts.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 0', color: '#9CA3AF' }}>
            <p style={{ fontSize: 18, marginBottom: 8 }}>Nenhum artigo publicado ainda.</p>
            <p style={{ fontSize: 14 }}>Volte amanhã — publicamos diariamente.</p>
          </div>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 28 }}>
              {posts.map(post => (
                <article key={post.id} style={{ background: '#fff', border: '1px solid #E4E0D4', borderRadius: 14, padding: 28, display: 'flex', flexDirection: 'column', gap: 12, transition: 'box-shadow 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.boxShadow = '0 8px 24px rgba(10,15,50,0.1)'}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
                >
                  {post.dor_tema && (
                    <span style={{ fontSize: 12, fontFamily: "'JetBrains Mono', monospace", color: '#1B2A7A', background: '#EEF2FF', padding: '4px 10px', borderRadius: 100, alignSelf: 'flex-start', letterSpacing: '0.05em' }}>
                      {DOR_LABEL[post.dor_tema] || post.dor_tema}
                    </span>
                  )}
                  <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 20, lineHeight: 1.3, color: '#0E1430', margin: 0 }}>
                    <a href={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>{post.title}</a>
                  </h2>
                  {post.summary && <p style={{ fontSize: 15, color: '#6A7091', lineHeight: 1.55, margin: 0 }}>{post.summary}</p>}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto', paddingTop: 12, borderTop: '1px solid #F0EDE8' }}>
                    <time style={{ fontSize: 12, color: '#9CA3AF' }}>{formatDate(post.published_at)}</time>
                    <a href={`/blog/${post.slug}`} style={{ fontSize: 13, color: '#1B2A7A', fontWeight: 600, textDecoration: 'none' }}>Ler artigo →</a>
                  </div>
                </article>
              ))}
            </div>

            {/* Pagination */}
            {pages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 48 }}>
                <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
                  style={{ padding: '8px 18px', border: '1px solid #E4E0D4', borderRadius: 8, background: '#fff', cursor: page === 1 ? 'not-allowed' : 'pointer', opacity: page === 1 ? 0.5 : 1, fontSize: 14 }}>
                  ← Anterior
                </button>
                <span style={{ padding: '8px 14px', fontSize: 14, color: '#6A7091' }}>{page} / {pages}</span>
                <button onClick={() => setPage(p => Math.min(pages, p + 1))} disabled={page === pages}
                  style={{ padding: '8px 18px', border: '1px solid #E4E0D4', borderRadius: 8, background: '#fff', cursor: page === pages ? 'not-allowed' : 'pointer', opacity: page === pages ? 0.5 : 1, fontSize: 14 }}>
                  Próxima →
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* CTA */}
      <div style={{ background: '#FFD400', padding: '56px 24px', textAlign: 'center' }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 900, fontSize: 'clamp(26px, 4vw, 40px)', color: '#0A0F33', letterSpacing: '-0.03em', marginBottom: 16 }}>
            Pronto para ter controle total da sua loja?
          </h2>
          <p style={{ fontSize: 18, color: '#1B2A7A', marginBottom: 28 }}>7 dias grátis. Sem cartão de crédito.</p>
          <a href="/" style={{ display: 'inline-block', background: '#0A0F33', color: '#FFD400', padding: '16px 36px', borderRadius: 100, fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 18, textDecoration: 'none', letterSpacing: '-0.01em' }}>
            Testar grátis →
          </a>
        </div>
      </div>
    </BlogLayout>
  );
}
